import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface CallStatusPayload {
    baseUrl: string;
    callId: string;
    userId: string;
}

export interface ConnectionDetails {
    serverUrl: string;
    roomName: string;
    participantToken: string;
    participantName: string;
    call_id: string;
}

export const getCallStatus = async (payload: CallStatusPayload): Promise<ConnectionDetails> => {
    const { baseUrl, callId, userId } = payload;
    const response = await axios.get(
        `${baseUrl}/voice/web/call/${callId}/status`,
        {
            headers: {
                "user-id": userId
            }
        }
    );

    return response.data;
};

export const useCallStatusPolling = (
    payload: CallStatusPayload & { enabled: boolean }
) => {
    return useQuery({
        queryKey: ["callStatus", payload.callId],
        queryFn: () => getCallStatus({
            baseUrl: payload.baseUrl,
            callId: payload.callId,
            userId: payload.userId
        }),
        enabled: payload.enabled && !!payload.callId,
        refetchInterval: (data) => {
            // Poll every second if serverUrl is empty, stop polling once populated
            // @ts-ignore
            return data?.serverUrl ? false : 1000;
        },
        staleTime: 0, // Always consider data stale for polling
        gcTime: 0 // Don't cache results
    });
};